module.exports = __webpack_public_path__ + "img/fireworks.6a6b3155.gif";